// extracted by mini-css-extract-plugin
module.exports = {"buttons":"MainButtonBlock_buttons__8wAYE"};